import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RedirectService {

  private redirectUrl = '';

  constructor(
    private router: Router
  ) { }

  redirectTo() {
    const urlTree = this.getRedirectUrlTree();
    this.clear();
    return urlTree;
  }

  getRedirectUrlWithoutParams() {
    const url = this.getRedirectUrl();
    return url.substring(0, url?.indexOf('?') === -1 ? url.length : url.indexOf('?'));
  }

  getRedirectParams() {
    return this.getRedirectUrlTree().queryParams;
  }

  getRedirectUrlTree() {
    return this.router.parseUrl(this.getRedirectUrl());
  }

  getRedirectUrl() {
    return this.redirectUrl;
  }

  setRedirectUrl(redirect: string) {
    this.redirectUrl = redirect;
  }

  clear() {
    this.redirectUrl = '';
  }

}
